import makeIsConsented from './makeIsConsented'
import unblockAndReplaceNode from './unblockAndReplaceNode'


/**
 * Releases the elements among `nodes` whose categories the visitor agreed to.
 *
 * @param {Element[]} nodes
 * @param {(string[]|Set<string>)} [categories] - when omitted, every element
 *   is released, whatever categories it declares
 */
export default function releaseNodes(nodes, categories) {
  // N.B: A blocked element nested inside another blocked element
  // comes back in document order, parent first.  Replacing the parent
  // deep-clones it, so the copy of the child inside that clone is
  // still blocked, and the child we go on to process is the original,
  // now sitting in the detached subtree. The clone's child is left
  // blocked by this pass.
  //
  // In practice the observer cleans it up, because inserting the
  // clone is itself a mutation and the nested element gets released
  // on the next tick.  Reaching this at all takes a manually-blocked
  // element nested inside another manually-blocked element, something like
  // an <object> or <iframe> wrapping a marked script, which is the
  // cornerest of corner cases. Fixing it properly means processing
  // deepest-first which would change ordering for the document-wide
  // sweeps too, which is very much out of scope for the current
  // story...and may be out of scope until the end of time. If someone
  // complains, we can fix this...but until then, I'm letting sleeping
  // dogs lie. Shhhh...good doggie.
  nodes
    .filter(makeIsConsented(categories))
    .forEach((node) => {
      unblockAndReplaceNode(node)
    })
}
